import { useContext } from 'react';
import AuthContext from 'src/contexts/AzureADContext';

const useAuth = () => useContext(AuthContext);

export default useAuth;
